import React from 'react';
import { connect } from 'react-redux';
import { makeGetTaskCreated } from '../../../../../redux/tasks/taskEntities/selectors';
import { useIntl } from 'react-intl';

const ConnectedTaskCreated = ({ createdAt }) => {
  const intl = useIntl();
  const time = intl.formatDate(createdAt) ;// moment(new Date(task?.createdAt)).format('DD MMM, YYYY')

  return <div className="text-xs text-center">{time}</div>;
};

const makeMapStateToProps = () => {
  const getTaskCreated = makeGetTaskCreated();
  return (state, props) => ({
    createdAt: getTaskCreated(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedTaskCreated);
